import React from 'react';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { selectColor } from '@panel/commons/core/theme';
import { useTranslation } from 'react-i18next';
import DropdownBranches from '../DropdownBranches';
import {
  HeaderNameContainer,
  TitleSection,
  TitleStyled,
  SubtitleContainer,
  SubtitleStyled,
  Icon,
  TooltipComponent,
  IconTooltip
} from './styles';
import TooltipHelper from '../../assets/icons/tooltipHelperDark.svg';
import ClockIcon from '../../assets/icons/clockIcon.svg';

const Header = ({
  title,
  subtitle,
  withTooltip,
  children,
  device,
  updateData,
  currentTab,
  branchSelected,
  setBranchSelected,
  branches
}) => {
  const { t } = useTranslation();
  const tooltipComponentHeader = () => {
    return (
      <TooltipComponent>
        {t('panel.estadisticas.header.subtitle', {
          date: updateData.date || 'DD/MM/YYYY',
          hour: updateData.hour || 'HH:mm'
        })}
      </TooltipComponent>
    );
  };

  return (
    <HeaderNameContainer>
      <TitleSection withTooltip={withTooltip}>
        <TitleStyled data-panel='panel-estadisticas-titleHeader'>{title}</TitleStyled>
        {withTooltip && (
          <SimpleTooltip
            offset={5}
            backgroundColor={selectColor('black')}
            isMobile={false}
            text={tooltipComponentHeader()}
            position='bottom-center'
            dataPanel='panel-estadisticas-tooltip'
            autoPlacements
          >
            <IconTooltip
              src={TooltipHelper}
              alt='tooltip-helper'
              width='16'
              height='16'
              data-panel='panel-estadisticas-icon-tooltip'
            />
          </SimpleTooltip>
        )}
        {device === 'tablet' && currentTab === 'reputation' && branches && branches.length > 1 && (
          <DropdownBranches
            width='328px'
            device={device}
            branchSelected={branchSelected}
            setBranchSelected={setBranchSelected}
            selectOptions={branches}
          />
        )}

        {device === 'tablet' && currentTab === 'score' && branches && branches.length > 1 && (
          <DropdownBranches
            width='328px'
            device={device}
            branchSelected={branchSelected}
            setBranchSelected={setBranchSelected}
            selectOptions={branches}
          />
        )}

        {device !== 'mobile' && children}
      </TitleSection>
      {device === 'mobile' && currentTab === 'reputation' && branches && branches.length > 1 && (
        <DropdownBranches
          device={device}
          branchSelected={branchSelected}
          setBranchSelected={setBranchSelected}
          selectOptions={branches}
        />
      )}

      {device === 'mobile' && currentTab === 'score' && branches && branches.length > 1 && (
        <DropdownBranches
          device={device}
          branchSelected={branchSelected}
          setBranchSelected={setBranchSelected}
          selectOptions={branches}
        />
      )}

      {device === 'mobile' && children}
      {subtitle && (
        <SubtitleContainer>
          <Icon src={ClockIcon} alt='clock-Icon' />
          <SubtitleStyled data-panel='panel-estadisticas-subtitleHeader' device={device}>
            {subtitle}
          </SubtitleStyled>
        </SubtitleContainer>
      )}
    </HeaderNameContainer>
  );
};

export default Header;
